import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import { useInView } from 'react-intersection-observer';
// No need for dynamic import of polyfill as it's not installed
// Most modern browsers support IntersectionObserver natively
render(<App data-id="element-322" />, document.getElementById('root'));